import { isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [],
  templateUrl: './login.html',
  styleUrls: ['./login.css'],
})
export class LoginComponent {
  private platformId = inject(PLATFORM_ID);

  public loginWithGoogle(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    window.location.href = '/api/auth/google';
  }
}
